module.exports = __webpack_public_path__ + "img/appltAliRGuide-1.8a2fe351.png";